import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import { ErrorCodes, Constants } from 'src/constants'

export default {
  computed: {
    ...mapGetters({
      user: 'passport/user',
      verificator: 'passport/defaultVerificator'
    })
  },
  data () {
    return {
      form: {
        code: ''
      },
      error: null,
      isErrorVisible: false,
      isBusy: false,
      isPasswordVisible: false,
      isResendCode: false,
      twofaConfirmationCodeLength: Constants.confirmation.twofaConfirmationCodeLength
    }
  },
  validations: {
    form: {
      code: {
        required,
        isComplex () {
          return this.form.code.length === this.twofaConfirmationCodeLength
        }
      }
    }
  },
  watch: {
    'form.code': {
      async handler () {
        if (!this.isResendCode && this.form.code.length === this.twofaConfirmationCodeLength) {
          await this.handleSubmit()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      disable2FA: 'passport/disable2FA'
    }),
    async handleSubmit () {
      this.isBusy = true
      this.isErrorVisible = false
      this.error = null
      setImmediate(async () => {
        try {
          await this.disable2FA({
            ...this.form
          })
          // setImmediate(() => {
          //   this.$router.push('/security/grant')
          // })
        } catch (e) {
          if (e.response.data.error.code === ErrorCodes.INTERNAL_ERROR) {
            this.error = 'Invalid code'
          } else {
            this.error = 'Unknown error'
          }
          this.isErrorVisible = true
        } finally {
          this.isBusy = false
          this.isResendCode = true
        }
      })
    }
  }
}
